export enum MessageMethod {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    READY = 'READY',
    OPENING = 'OPENING',
    CLOSING = 'CLOSING',
    RESIZE = 'iframeResize',
    RELOAD_BALANCE = 'pamReloadUserBalance',
    GEOLOCATION_READY_NATIVE = 'external_geolocation_iframe_ready',
    REFRESH = 'REFRESH',
    TOKEN = 'external_send_geo_token',
    LOADED = 'LOADED',
    TEST = 'TEST',
}

export interface ILoginMessage {
    method: MessageMethod.LOGIN;
    args: {
        sessionId: string;
        geolocationToken?: string;
    };
}

export interface TestMessage {
    method: MessageMethod.TEST;
    message: string;
}

export interface ILoadedMessage {
    method: MessageMethod.LOADED;
    message: string;
}

export interface ILogoutMessage {
    method: MessageMethod.LOGOUT;
    args: {
        sessionId: string;
    };
}

export interface SendToken {
    method: MessageMethod.TOKEN;
    message: 'external_send_geo_token';
    args: {
        token: string;
    };
}
export interface IframeReady {
    method: MessageMethod.READY;
    message: 'external_tokens_iframe_ready';
}

export interface NativeGeolocation {
    method: MessageMethod.GEOLOCATION_READY_NATIVE;
    message: 'external_geolocation_iframe_ready';
}

export interface IOpeningMessage {
    method: MessageMethod.OPENING;
}

export interface IClosingMessage {
    method: MessageMethod.CLOSING;
}

export interface IFrameResizeMessage {
    method: MessageMethod.RESIZE;
    args: {
        height: string;
        srcUrl: string;
    };
}

export interface IReloadBalanceMessage {
    method: MessageMethod.RELOAD_BALANCE;
}

export type SportNCoMessage =
    | ILoginMessage
    | IOpeningMessage
    | SendToken
    | ILogoutMessage
    | ILoadedMessage
    | IClosingMessage
    | IFrameResizeMessage
    | TestMessage
    | IframeReady
    | NativeGeolocation
    | IReloadBalanceMessage;
